export default function() {
  const mozilla = window.Mozilla;
  const isFirefox = mozilla && (mozilla.isFirefox || mozilla.isLikeFirefox);
  // Edge and Samsung Internet may also have a window.chrome
  const isChrome =
    window.chrome &&
    !/Edg(e|iOS|A)\/|SamsungBrowser/i.test(navigator.userAgent);
  // Doesn't matter whether window.isSecureContext is true or false, just that it's not null/undefined
  const hasSecureContextDetermination = window.isSecureContext != null;
  return hasSecureContextDetermination && !!(isFirefox || isChrome);
}
